import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#000",
      light: "#e35205",  // Example of an additional shade
      dark: "#fa6600",   // Example of an additional shade
    },
    secondary: {
      main: "#fa6600",
    },
    // Custom color categories
    error: {
      main: "#f44336",
      light: "#e57373",
      dark: "#d32f2f",
    },
    warning: {
      main: "#ff9800",
    },
    info: {
      main: "#2196f3",
    },
    success: {
      main: "#4caf50",
    },
    customGray: {  // Completely custom color category
      main: "#BDBDBD",
      light: "#E0E0E0",
      dark: "#9E9E9E",
    },
    // Add other colors as needed
  },
  typography: {
    body1: {
      fontSize: "1rem",
      color: "#757575",
    },
    body2: {
      fontSize: "0.9rem",
      color: "#3b3b3b",
    },
  },
  components: {
    MuiPickersToolbar: {
      styleOverrides: {
        root: {
          color: "#1565c0",
          borderRadius: "2px",
          borderWidth: "1px",
          borderColor: "#2196f3",
          border: "1px solid",
          backgroundColor: "#90caf9",
        }
      }
    }
  }
});


export default theme;
